import React from "react";
import { useSelector } from "react-redux";
import { fullName } from "../../../services/utilities";

const GeneratedBy = () => {
  const { auth } = useSelector(({ auth }) => auth);
  return (
    <div className="mt-3">
      <div className="d-flex align-items-center">
        <h6 className="fw-bold">Generated By:</h6>
        <h6 className="ml-1">{fullName(auth.fullName)}</h6>
      </div>
      <div className="d-flex align-items-center">
        <h6 className="fw-bold">Date Created:</h6>
        <h6 className=" ml-1">
          {new Date().toLocaleString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          })}
        </h6>
      </div>
    </div>
  );
};

export default GeneratedBy;
